import { render, staticRenderFns } from "./posterImage.vue?vue&type=template&id=11b8457e&scoped=true&"
import script from "./posterImage.vue?vue&type=script&lang=js&"
export * from "./posterImage.vue?vue&type=script&lang=js&"
import style0 from "./posterImage.vue?vue&type=style&index=0&id=11b8457e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8457e",
  null
  
)

component.options.__file = "posterImage.vue"
export default component.exports